<template>
  <v-container>
    <!-- <v-container fluid class="pa-0 ma-0">
      <v-img max-height="25vh" :src="event.header" />
    </v-container> -->
    <v-container class="pa-6 pt-10" fluid>
      <v-row>
        <v-col cols="12" class="col-md-6">
          <h1>{{ $t("Edit Post") }}</h1>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="services-list">
      <v-row dense>
        <!-- manage teams -->
        <v-col class="col-sm-12 col-md-12">
          <v-card class="pa-0" flat>
            <v-card-text>
              <v-col cols="6" class="align-center">
                <v-text-field
                  label="Name"
                  v-model="currentPage.name"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="align-center">
                <v-text-field
                  label="Description"
                  v-model="currentPage.description"
                ></v-text-field>
              </v-col>
              <v-col class="align-center">
                <div class="editorx_body">
                  <!--editorjs id-->
                  <div class :id="`codex-editor`" />
                </div>
                <div class="editorx_body"></div>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <v-col class="text-right">
            <v-btn color="green lighten-2" text @click="saveGame">
              {{ $t("Ok") }}
            </v-btn>
            <v-btn color="red lighten-2" text @click="reset">
              {{ $t("Cancel") }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);

import EditorJS from "@editorjs/editorjs";
import Header from "editorjs-header-with-anchor";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
import SimpleImage from "@editorjs/simple-image";

export default {
  name: "GameExperiencePageEdit",
  route: {
    path: "/posts/edit/:pageId",
    name: "Games Experience Add Page",
  },
  data: () => ({
    currentPage: {
      id: 0,
      name: "New Page - " + new Date(),
      description: "",
      content: Object,
      image: "",
    },
    editor: null,
    editorexperience: null,
  }),
  components: {},
  beforeMount() {
    this.getPost();
  },
  methods: {
    async getPost() {
      this.posts = [];
      const postsRef = db.collection("posts");
      const data = await postsRef.doc(this.$route.params.pageId).get();
      let post = data.data();
      post.content = {};
      post.content.blocks = data.data().content.blocks;
      post.content.time = data.data().content.time;
      post.content.version = data.data().content.version;
      this.currentPage = post;
      this.setupEditor();
    },
    async saveGame() {
      this.editor.save().then((savedData) => {
        this.currentPage.content = savedData;
        db.collection("posts").doc(String(this.$route.params.pageId)).set(this.currentPage, {merge: true}).then(() => {
          this.$router.push(`/posts`);
        });
      });
    },
    setupEditor() {
      console.log(this.currentPage.content);
      this.editor = new EditorJS({
        readOnly: false,
        holder: `codex-editor`,
        autofocus: true,
        onReady: function () {
          console.log("ready");
        },
        data: this.currentPage.content,
        tools: {
         header: {
            class: Header,
            shortcut: "CMD+SHIFT+H",
            config: {
              placeholder: "Enter a header",
              levels: [2, 3, 4],
              defaultLevel: 3,
              allowAnchor: true,
              anchorLength: 100,
            },
          },
          list: {
            class: List,
          },
          paragraph: {
            class: Paragraph,
            config: {
              placeholder: ".",
            },
          },
          image: {
            class: SimpleImage,
            inlineToolbar: true,
            config: {
              placeholder: "Paste image URL",
            },
          },
        },
        onChange: function () {},
      });
    },
    reset() {
      this.$router.push(`/posts`);
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
a {
  text-decoration-line: none;
}
.services-list {
  .v-card {
    min-height: 250px;
  }
}
</style>
